import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { MobileProvider } from './contexts/MobileContext'
import './index.css'

const toastConfig = {
  position: 'top-right' as const,
  duration: 4000,
  style: {
    background: '#1e293b',
    color: '#f8fafc',
    border: '1px solid #334155',
  },
  success: { iconTheme: { primary: '#10b981', secondary: '#f8fafc' } },
  error: { iconTheme: { primary: '#ef4444', secondary: '#f8fafc' } },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <MobileProvider>
          <App />
          <Toaster {...toastConfig} />
        </MobileProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
